import { result, chain, isEmpty } from 'underscore';
import type {
  IPreference, IPreferenceService, IPreferenceServiceProps,
} from './types';

export class PreferenceService<TValue> {
  preferenceKey: string;

  preferenceService: IPreferenceService<TValue>;

  constructor(props: IPreferenceServiceProps<TValue>) {
    this.preferenceKey = result(props, 'preferenceKey');
    this.preferenceService = result(props, 'preferenceService');

    this.initializePreference();
  }

  initializePreference = () => {
    if (isEmpty(this.preferenceService)) {
      throw new Error('PreferenceService does not exist');
    }

    let preference = this.getUserLevelPreference();
    // initialize the preference if it does not exist
    if (isEmpty(preference)) {
      preference = {
        Name: this.preferenceKey,
        Data: {},
        Type: 'string',
        Version: 1,
      };
      this.preferenceService.setAtUserLevel(preference);
    }
  };

  getUserLevelPreference = () => this.preferenceService
    .findByNameAtUserLevel(this.preferenceKey) as IPreference<TValue>;

  getPreference = (key: string): TValue | undefined => {
    const preference = this.getUserLevelPreference();
    return chain(preference)
      .result('Data')
      .result(key)
      .value() as TValue | undefined;
  };

  setPreference = (key: string, state: TValue) => {
    const preference = this.getUserLevelPreference();
    preference.Data[key] = state;
    this.preferenceService.setAtUserLevel(preference);
  };

  getDaysAfter = (days: number) => {
    if (days === Infinity) {
      return new Date(8640000000000000);
    }

    const date = new Date();
    date.setTime(date.getTime() + (86400000 * days));
    return date;
  };
}
